'use client'

import { useEffect } from 'react'
import { useLogger } from 'next-axiom'

interface Props {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: Props) {
  const log = useLogger({ source: 'client-error' })

  useEffect(() => {
    log.error('client.error.boundary', {
      message: error.message,
      digest: error.digest,
    })
    void log.flush()
  }, [error, log])

  return (
    <html lang="en">
      <head>
        {/* WCAG 2.4.2 (document-title): the built-in Next.js global error page
            renders <html id="__next_error__"> with no <title>, which fails the
            axe-core document-title rule on any route that hits it (AQSN-169).
            Providing this custom global-error boundary with a non-empty title
            replaces that title-less default. */}
        <title>Something went wrong | AgencyQ</title>
      </head>
      <body>
        <main>
          <section className="p-8 text-center">
            <h1>Something went wrong</h1>
            <p>We&apos;ve been notified and are working on a fix.</p>
            <button type="button" onClick={reset}>Try again</button>
          </section>
        </main>
      </body>
    </html>
  )
}
